import React from 'react';
import LandScapeImage from "../../Images/Landscape/landscape-14.jpeg"
import ExcavationSvg from "../../Images/Icons/Excavation.svg";
import RockworkSvg from "../../Images/Icons/Rockwork.svg"
import BuildSvg from "../../Images/Icons/Build.svg"
import DesignSvg from "../../Images/Icons/Design.svg"
import LandscapingSvg from "../../Images/Icons/Landscaping.svg"
import MaintenanceSvg from "../../Images/Icons/Maintenance.svg"
import SnowSvg from "../../Images/Icons/Snow.svg"
import OutdoorSvg from "../../Images/Icons/Outdoor.svg"
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Home = () => {
  return (
    <div className="homepage-wrapper">
      <div className="homepage-home-hero-wrapper">
        <div className="homepage-home-hero-background" />

        <div className="homepage-home-hero-content-container">
          <div className="homepage-home-hero-content-wrapper">
            <h1 className="homepage-home-hero-content-header">
              Make Your Neighbors Green with Envy Using Our Professional Landscaping Services
            </h1>

            <NavLink 
              className="homepage-home-hero-content-subtext"
              to="/book-consultation"
            >
              Book Now
            </NavLink>
          </div>
        </div>

        <div className="homepage-home-hero-image-skew-one"></div>
        <div className="homepage-home-hero-image-skew-two"></div>
      </div>

      <div className="homepage-introduction-section-wrapper">
        <div className="homepage-introduction-container">
          <div className="homepage-introduction-wrapper">
            <h2 className="homepage-introduction-header">
              Transform Your Outdoor Space with Professional Landscaping Services
            </h2>

            <h3 className="homepage-introduction-subheader">
              Enhance Your Property's Beauty and Functionality with Our Expertise
            </h3>

            <div className="homepage-introduction-text">
              Our skilled team of landscapers and designers provide high-quality services for homeowners and businesses. We offer landscape design, installation, maintenance, hardscaping, irrigation, and more. From initial consultation to final installation, we work closely with our clients to ensure that every project meets their needs and exceeds their expectations. Contact us today to schedule a consultation and see how we can help you achieve your landscaping goals.
            </div>
          </div>

          <div className="homepage-introduction-image-wrapper">
            <img
              src={LandScapeImage}
              className="homepage-introduction-image"
            />
          </div>
        </div>

        <div className="homepage-awards-container">
          <h3 className="homepage-awards-header">
           Awarded Neighborhood Fave
          </h3>

          <div className="homepage-awards-wrapper">
            <div className="homepage-award-wrapper">
              <div className="homepage-award-year">2024</div>

              <FontAwesomeIcon 
                className="homepage-award-icon"
                icon={['fas', 'medal']}
                style={{
                  
                }}
              />

              <a className="homepage-award-location" target="_blank" href="https://nextdoor.com/page/eo-landscape?init_source=search">
                Nextdoor <div><FontAwesomeIcon icon={['fas', 'arrow-right']} /></div>
              </a>
            </div>

            <div className="homepage-award-wrapper">
              <div className="homepage-award-year">
                2025
              </div>

              <FontAwesomeIcon
                className="homepage-award-icon"
                icon={['fas', 'medal']}
              />

              <a className="homepage-award-location" target="_blank" href="https://nextdoor.com/page/eo-landscape?init_source=search">
                Nextdoor <div><FontAwesomeIcon icon={['fas', 'arrow-right']} /></div>
              </a>
            </div>
          </div>
        </div>

        <div className="homepage-introduction-testimonials-wrapper">
          <div className="homepage-introduction-testimonial-wrapper">
            <div className="homepage-introduction-testimonial-text">
              "We are extremely happy that we decided to hire E&O for our new landscape project, irrigation changes, and a foundation for our new Tuff Shed. From the start, the crew at E&O were prompt, friendly, professional, and seemed to care about our satisfaction, which is very important to us. The entire experience was a stress-free success and we would recommend them 100%."
            </div>

            <a target="_blank" href="https://www.google.com/search?sca_esv=dc37c2f0b8a15054&rlz=1C5OZZY_enUS1150US1150&sxsrf=ANbL-n7JB1_X358HJLMiKZ-ktQM2q0KnJg:1778966894168&si=AL3DRZEsmMGCryMMFSHJ3StBhOdZ2-6yYkXd_doETEE1OR-qOcRSTI2hABh1MmKrm0LGZ91sOdOLzrptPuNVnpshffSOXOm3sko-FqDYDnmUK8iDIsuY_QSxrriFYYJSLedkd2n4v2z9&q=E%26O+Landscape+Reviews&sa=X&ved=2ahUKEwjE7KyO4L6UAxWoJUQIHc7bHR8Q0bkNegQIOxAF&biw=1460&bih=743&dpr=2" className="homepage-introduction-testimonial-author">
              - Google <FontAwesomeIcon style={{ paddingLeft: "5px" }} icon={['fas', 'arrow-right']} />
            </a>
          </div>

          <div className="homepage-introduction-testimonial-wrapper">
            <div className="homepage-introduction-testimonial-text">
              "Incredibly professional, easy to schedule and amazing service. I will definitely use E&O for any needs at my home as well as my rental properties."
            </div>

            <a target="_blank" href="https://www.facebook.com/EandO.Landscape/reviews/" className="homepage-introduction-testimonial-author">
              - Facebook <FontAwesomeIcon style={{ paddingLeft: "5px" }} icon={['fas', 'arrow-right']} />
            </a>
          </div>

          <div className="homepage-introduction-testimonial-wrapper">
            <div className="homepage-introduction-testimonial-text">
              "Highly recommend! I’ve received concrete work from a few companies in Heber and this was by far my best experience. They showed up on time, finished the work exactly when they told me they would, and had very fair prices. This project took 3 days from quote to poured concrete."
            </div>

            <a target="_blank" href="https://www.google.com/search?sca_esv=dc37c2f0b8a15054&rlz=1C5OZZY_enUS1150US1150&sxsrf=ANbL-n7JB1_X358HJLMiKZ-ktQM2q0KnJg:1778966894168&si=AL3DRZEsmMGCryMMFSHJ3StBhOdZ2-6yYkXd_doETEE1OR-qOcRSTI2hABh1MmKrm0LGZ91sOdOLzrptPuNVnpshffSOXOm3sko-FqDYDnmUK8iDIsuY_QSxrriFYYJSLedkd2n4v2z9&q=E%26O+Landscape+Reviews&sa=X&ved=2ahUKEwjE7KyO4L6UAxWoJUQIHc7bHR8Q0bkNegQIOxAF&biw=1460&bih=743&dpr=2" className="homepage-introduction-testimonial-author">
              - Google <FontAwesomeIcon style={{ paddingLeft: "5px" }} icon={['fas', 'arrow-right']} />
            </a>
          </div>

          <div className="homepage-introduction-testimonial-wrapper">
            <div className="homepage-introduction-testimonial-text">
              "Excellent communication, conscientious workers, and project completed on time.  100% recommend."
            </div>

            <a target="_blank" href="https://www.facebook.com/EandO.Landscape/reviews/" className="homepage-introduction-testimonial-author">
              - Facebook <FontAwesomeIcon style={{ paddingLeft: "5px" }} icon={['fas', 'arrow-right']} />
            </a>
          </div>

          <div className="homepage-introduction-testimonial-wrapper">
            <div className="homepage-introduction-testimonial-text">
              "Alex and his crew were great to work with. Alex provided a very fair quote, showed up on time, and did excellent work. I highly recommend them!"
            </div>

            <a target="_blank" href="https://www.google.com/search?sca_esv=dc37c2f0b8a15054&rlz=1C5OZZY_enUS1150US1150&sxsrf=ANbL-n7JB1_X358HJLMiKZ-ktQM2q0KnJg:1778966894168&si=AL3DRZEsmMGCryMMFSHJ3StBhOdZ2-6yYkXd_doETEE1OR-qOcRSTI2hABh1MmKrm0LGZ91sOdOLzrptPuNVnpshffSOXOm3sko-FqDYDnmUK8iDIsuY_QSxrriFYYJSLedkd2n4v2z9&q=E%26O+Landscape+Reviews&sa=X&ved=2ahUKEwjE7KyO4L6UAxWoJUQIHc7bHR8Q0bkNegQIOxAF&biw=1460&bih=743&dpr=2" className="homepage-introduction-testimonial-author">
              - Google <FontAwesomeIcon style={{ paddingLeft: "5px" }} icon={['fas', 'arrow-right']} />
            </a>
          </div>

          <div className="homepage-introduction-testimonial-wrapper">
            <div className="homepage-introduction-testimonial-text">
              "I give them 10 plus. They did an excellent job and completed the project timely. Very professional."
            </div>

            <a target="_blank" href="https://www.facebook.com/EandO.Landscape/reviews/" className="homepage-introduction-testimonial-author">
              - Facebook <FontAwesomeIcon style={{ paddingLeft: "5px" }} icon={['fas', 'arrow-right']} />
            </a>
          </div>
        </div>
      </div>

      <div className="homepage-services-wrapper">
        <div className="homepage-service-wrapper">
          <div className="homepage-service-icon-wrapper">
            <img className="homepage-service-icon" src={DesignSvg} />
          </div>

          <div className="homepage-service-text">
            Design
          </div>
        </div>

        <div className="homepage-service-wrapper">
          <div className="homepage-service-icon-wrapper">
            <img className="homepage-service-icon" src={BuildSvg} />
          </div>

          <div className="homepage-service-text">
            Build
          </div>
        </div>

        <div className="homepage-service-wrapper">
          <div className="homepage-service-icon-wrapper">
            <img className="homepage-service-icon" src={RockworkSvg} />
          </div>

          <div className="homepage-service-text">
            Rock Work
          </div>
        </div>

        <div className="homepage-service-wrapper">
          <div className="homepage-service-icon-wrapper">
            <img className="homepage-service-icon" src={ExcavationSvg} />
          </div>

          <div className="homepage-service-text">
            Excavation
          </div>
        </div>

        <div className="homepage-service-wrapper">
          <div className="homepage-service-icon-wrapper">
            <img className="homepage-service-icon" src={OutdoorSvg} />
          </div>

          <div className="homepage-service-text">
            Outdoor Construction
          </div>
        </div>

        <div className="homepage-service-wrapper">
          <div className="homepage-service-icon-wrapper">
            <img className="homepage-service-icon" src={LandscapingSvg} />
          </div>

          <div className="homepage-service-text">
            Landscaping
          </div>
        </div>

        <div className="homepage-service-wrapper">
          <div className="homepage-service-icon-wrapper">
            <img className="homepage-service-icon" src={MaintenanceSvg} />
          </div>

          <div className="homepage-service-text">
            Maintenance
          </div>
        </div>

        <div className="homepage-service-wrapper">
          <div className="homepage-service-icon-wrapper">
            <img className="homepage-service-icon" src={SnowSvg} />
          </div>

          <div className="homepage-service-text">
            Snow Removal
          </div>
        </div>
      </div>

      <div className="homepage-outro-wrapper">
        <h2 className="homepage-outro-header">
          Your Premier Landscaping Service Provider
        </h2>

        <div className="homepage-outro-text">
          We are dedicated to providing exceptional landscaping services that exceed your expectations. Whether you are looking for routine lawn care, landscape design and installation, or hardscape construction, our team of professionals is ready to transform your outdoor space into a beautiful oasis.
        </div>
      </div>
    </div>
  )
}

export default Home;

